import { AppConfig } from '../app.config';

export class AppConfigService {
    constructor(public appConfig: AppConfig) {}
}
